/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type WidgetTypeRouter_report = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTypeRouter_report",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "withReportFilterProps_report",
      "args": null
    }
  ],
  "type": "Report"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/WidgetTypeRouter/__generated__/WidgetTypeRouter_report.graphql.js